/** Toggle label for in-feed discussion accordion. */
export function feedDiscussionToggleLabel(replyCount: number, expanded: boolean): string {
  if (expanded) return 'Hide replies';
  if (replyCount <= 0) return 'View replies';
  if (replyCount === 1) return '1 reply';
  return `${replyCount} replies`;
}
